// extracted by mini-css-extract-plugin
export var change = "_3f-1";
export var changeList = "_3f-0";
export var changePath = "_3f-2";
export var diffArrow = "_3f-5";
export var diffRow = "_3f-3";
export var diffValue = "_3f-4";
export var error = "_3f-8";
export var notice = "_3f-9";
export var result = "_3f-6";
export var success = "_3f-7";